const HIGHLIGHT_NAME = 'search-results';

const rangesByOwner = new Map<string, Range[]>();
const listeners = new Set<() => void>();
let matchCount = 0;

function notifyListeners() {
  listeners.forEach((fn) => fn());
}

function rebuildHighlight() {
  const allRanges = Array.from(rangesByOwner.values()).flat();
  matchCount = allRanges.length;

  if (typeof CSS !== 'undefined' && CSS.highlights) {
    if (allRanges.length === 0) {
      CSS.highlights.delete(HIGHLIGHT_NAME);
    } else {
      CSS.highlights.set(HIGHLIGHT_NAME, new Highlight(...allRanges));
    }
  }

  notifyListeners();
}

export function registerRanges(ownerId: string, ranges: Range[]) {
  if (ranges.length === 0) {
    rangesByOwner.delete(ownerId);
  } else {
    rangesByOwner.set(ownerId, ranges);
  }
  rebuildHighlight();
}

export function unregisterRanges(ownerId: string) {
  rangesByOwner.delete(ownerId);
  rebuildHighlight();
}

export function subscribeMatchCount(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function getMatchCount() {
  return matchCount;
}
